<script>
import Layout from "./base";
import Swal from "sweetalert2";
/**
 * Starter component
 */
export default {
    components: { Layout,  },
    props:{
        submiturl: {
        type: String,
        required: true
        },
        autherror: {
        type: String,
        required: false,
        default: () => null
        },
        autenticado:'',
    },
    data() {
        return {
            title: "Starter Page",
            items: [
            {
                text: "Utility",
                href: "/"
            },
            {
                text: "Starter Page",
                active: true
            }
            ],
            item:0,
            productos:[],
            todos_productos:[],
            productosSeleccionados: [], // Arreglo para almacenar los productos seleccionados
            producto_ver:{
                producto:'',
                marca:'',
                presentacion:'',
                caracteristicas:'',
                imagen:''
            },
            windowWidth2: window.innerWidth,
            windowHeight2: window.innerHeight,
            listas:[],
            universidades:[],
            listasConUniversidades:[],
            listaSeleccionada:null,
            universidadSeleccionada:null,
            busqueda:''
        };
    },
    computed:{
        cartTotal() {
            let total=0;
            this.productosSeleccionados.forEach(element => {
                total = total + (parseInt(element.precio_estudiante)*parseInt(element.cantidad));
            });
            return total;
        },
        cartTotalP() {
            let total=0;
            this.productosSeleccionados.forEach(element => {
                total = total + (parseInt(element.precio_normal)*parseInt(element.cantidad));
            });
            return total;
        },
        
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    methods:{
        handleResize() {
            this.windowWidth2 = window.innerWidth;
            this.windowHeight2 = window.innerHeight;
        },
        format_Valor_variable(val){
            const number = parseInt(val?.toString().replace(/[^0-9]/g, ""), 10);
            return number
                ? number.toLocaleString("es-CL", { style: "currency", currency: "CLP" })
                : "$0";
        },
        agregarProducto(index) {
            // Cambia el estado de agregar a true
            this.productos[index].agregar = true;
            this.productos[index].cantidad = 1;// Inicializa la cantidad en 1
            this.productosSeleccionados = this.productos.filter((producto) => producto.agregar);
        },
        incrementarItem(index) {
            const producto = this.productos[index];
            if (producto.cantidad < producto.stock) {
                producto.cantidad += 1;
                this.productosSeleccionados = this.productos.filter((producto) => producto.agregar);
            } else {
                this.msg('error','Máximo stock',`No puedes agregar más de ${producto.stock} unidades de este producto.`)
                //alert(`No puedes agregar más de ${producto.stock} unidades de este producto.`);
            }
        },
        decrementarItem(index) {
            if (this.productos[index].cantidad > 1) {
                this.productos[index].cantidad -= 1;
                this.productosSeleccionados = this.productos.filter((producto) => producto.agregar);
            } else {
                // Si la cantidad llega a 0, desactiva el producto
                this.productos[index].agregar = false;
                this.productos[index].cantidad = 0;
            }
        },
        confirmarSeleccion() {
            // Filtra los productos que tienen agregar = true
            this.productosSeleccionados = this.productos.filter((producto) => producto.agregar);
            // Redirigir o manejar los datos para otra vista
            console.log("Productos seleccionados:", this.productosSeleccionados);
            sessionStorage.setItem("estudiante", JSON.stringify(this.productosSeleccionados));
            window.location.href='/confirmarcompra'
            // Aquí podrías redirigir a otra vista o almacenar los datos
            // Ejemplo: this.$router.push({ name: 'otraVista', params: { productos: this.productosSeleccionados } });
        },
        msg(tipo,titulo,data){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                text: data,
                showConfirmButton: false,
                timer: 1500
            });
        },
        ver_detalles(producto){
            //this.producto_ver=producto
            if (producto.tipo=='Producto Web') {
                this.producto_ver.producto=producto.productoweb.nombre;
                this.producto_ver.marca=producto.productoweb.marca;
                this.producto_ver.presentacion='';
                this.producto_ver.caracteristicas=producto.productoweb.desccorta;
                this.producto_ver.imagen=producto.productoweb.foto_dir;
            }else{
                if(producto.productoweb!=null){
                    this.producto_ver.producto=producto.productoweb.nombre;
                    this.producto_ver.marca=producto.productoweb.marca;
                    this.producto_ver.presentacion=producto.productoweb.presentacion;
                    this.producto_ver.caracteristicas=producto.productoweb.caracteristicas;
                    this.producto_ver.imagen=producto.productoweb.foto_dir;
                }
            }       
            this.$refs['modal_ficha'].show()
        },
        formattedText(text) {
            return text.replace(/\n/g, '<br><br>');
        },
        filtro_universidad(uni){
            this.universidadSeleccionada = uni
            if (this.universidadSeleccionada==null) {
                this.productos = Array.from(
                    new Map(
                        this.todos_productos.reduce((acc, producto) => {
                            const clave = producto.codigo;
                            if (!acc.has(clave) || (!acc.get(clave).precio_normal && producto.precio_normal)) {
                                acc.set(clave, { 
                                    ...producto, 
                                    agregar: false, 
                                    cantidad: 0 
                                });
                            }
                            return acc;
                        }, new Map())
                    ).values()
                );
                this.productos_filtro = this.productos;
            }else{
                // Filtra los productos según la universidad seleccionada
                this.productos = Array.from(
                    new Map(
                        this.todos_productos
                            .filter(producto => 
                                producto.listas.some(lista => lista.universidad === this.universidadSeleccionada)  // Verifica si alguna lista contiene la universidad seleccionada
                            )
                            .reduce((acc, producto) => {
                                const clave = producto.codigo;
                                if (!acc.has(clave) || (!acc.get(clave).precio_normal && producto.precio_normal)) {
                                    acc.set(clave, { 
                                        ...producto, 
                                        agregar: false, 
                                        cantidad: 0 
                                    });
                                }
                                return acc;
                            }, new Map())
                    ).values()
                );
                this.productos_filtro = this.productos;
            }
            // Filtra las listas para que solo muestren aquellas que contienen la universidad seleccionada
            this.listas = this.listasConUniversidades.filter((lista) => lista.universidad === this.universidadSeleccionada);
        },
        filtro_lista(uni){
            this.listaSeleccionada = uni
            if (this.listaSeleccionada==null) {
                this.productos = Array.from(
                    new Map(
                        this.todos_productos.reduce((acc, producto) => {
                            const clave = producto.codigo;
                            if (!acc.has(clave) || (!acc.get(clave).precio_normal && producto.precio_normal)) {
                                acc.set(clave, { 
                                    ...producto, 
                                    agregar: false, 
                                    cantidad: 0 
                                });
                            }
                            return acc;
                        }, new Map())
                    ).values()
                );
                this.productos_filtro = this.productos;
            }else{
                // Filtra los productos según la universidad seleccionada
                this.productos = Array.from(
                    new Map(
                        this.todos_productos
                            .filter(producto => 
                                producto.listas.some(lista => lista.nombre_lista === this.listaSeleccionada)  // Verifica si alguna lista contiene la universidad seleccionada
                            )
                            .reduce((acc, producto) => {
                                const clave = producto.codigo;
                                if (!acc.has(clave) || (!acc.get(clave).precio_normal && producto.precio_normal)) {
                                    acc.set(clave, { 
                                        ...producto, 
                                        agregar: false, 
                                        cantidad: 0 
                                    });
                                }
                                return acc;
                            }, new Map())
                    ).values()
                );
                this.productos_filtro = this.productos;
            }
        },
        filteredProducts() {
            this.productos = this.productos_filtro.filter(product =>
                product.nombre_producto.toLowerCase().includes(this.busqueda.toLowerCase())
            );
        }
    },
    created(){
        axios.get('/api/productos_lista/1').then(res=>{
            this.listasConUniversidades = res.data.listasuni;
            this.listas = res.data.listasuni;
            this.todos_productos = res.data.productos;
            this.productos = Array.from(
                new Map(
                    res.data.productos.reduce((acc, producto) => {
                        const clave = producto.codigo;
                        if (!acc.has(clave) || (!acc.get(clave).precio_normal && producto.precio_normal)) {
                            acc.set(clave, { 
                                ...producto, 
                                agregar: false, 
                                cantidad: 0 
                            });
                        }
                        return acc;
                    }, new Map())
                ).values()
            );
            this.productos_filtro = this.productos;
            // Obtener listas únicas de nombres y universidades
            const listasNombres = new Set();
            const universidades = new Set();
            this.productos.forEach(producto => {
                if (producto.listas) {
                    producto.listas.forEach(lista => {
                        // Crear un objeto con nombre de la lista y universidad
                        
                        listasNombres.add(lista.nombre_lista);
                        universidades.add(lista.universidad);
                    });
                }
            });
            // Convertir Sets a Arrays
            //this.listas = Array.from(listasNombres);
            this.universidades = Array.from(universidades);
        })
        .catch((error) => {
            console.error("Error al cargar los productos:", error);
        });
    }
};
</script>
<template>
    <Layout :submiturl='submiturl' :autherror="autherror" :autenticado="autenticado">
        <div class="row">
            <div class="col-12">
                <div class="card bg-light">
                    <div class="card-body">
                        <h2 class="text-center text-primary mb-3">Listas de Materiales</h2>
                        <div class="row m-1">
                            <div class="col-md-12 text-center mb-5" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                                <div class="containerb">
                                    <div class="search-box">
                                        <span class="icon pl-3 pt-1"><i class="bx bx-search-alt"></i></span>
                                        <input type="text" class="pt-3" placeholder="Buscar en listado" v-model="busqueda" @input="filteredProducts">
                                    </div>
                                    <div class="filters">
                                        <!-- <b-dropdown variant="none" class="filter" v-if="windowWidth2>576">
                                            <template v-slot:button-content>
                                                <p class="p-0 m-0">
                                                <i class="bx bx-buildings"></i> {{ universidadSeleccionada || "Universidad" }} 
                                                <i class="mdi mdi-chevron-down"></i>
                                                </p>
                                            </template>
                                            <b-dropdown-item 
                                                @click="filtro_universidad(null)"
                                            >
                                                Ninguna
                                            </b-dropdown-item>
                                            <b-dropdown-item 
                                                v-for="(uni, index) in universidades" 
                                                :key="index" 
                                                @click="filtro_universidad(uni)"
                                            >
                                                {{ uni }}
                                            </b-dropdown-item>
                                        </b-dropdown> -->
                                        <b-dropdown variant="none" class="filter" boundary="window">
                                            <template v-slot:button-content>
                                                <p class="p-0 m-0">
                                                <i class="bx bx-buildings"></i> {{ listaSeleccionada || "Listas universidades" }} 
                                                <i class="mdi mdi-chevron-down"></i>
                                                </p>
                                            </template>
                                            <b-dropdown-item 
                                                @click="filtro_lista(null)"
                                            >
                                                Ninguna
                                            </b-dropdown-item>
                                            <b-dropdown-item 
                                                v-for="(lis, index) in listas" 
                                                :key="index" 
                                                @click="filtro_lista(lis.nombre_lista)"
                                            >
                                                {{ lis.nombre_lista }}
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6" v-for="(producto,index) in productos" :key="index" v-show="producto.stock!='0'">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-7 d-flex flex-column">
                                                <label class="mb-0">{{index+1+'. '+producto.nombre_producto }}</label>
                                                <b-button class="text-left text-primary m-0 p-0" variant="link" @click="ver_detalles(producto)" v-if="producto.productoweb!=null"><u>Ver más</u></b-button>
                                                <p class="m-0 p-0 text-primary">{{producto.productoweb!=null?producto.productoweb.marca:''}}</p>
                                            </div>
                                            <div :class="windowWidth2>576?'col-md-5': 'col-md-5 pt-1'" style="display: flex;">
                                                <b-button class="fixed-button" variant="primary" @click="agregarProducto(index)" v-if="!producto.agregar">Agregar</b-button>
                                                <div style="display: flex; align-items: center; gap: 12px;" v-else>
                                                    <b-button variant="primary" size="sm" @click="decrementarItem(index)">-</b-button>
                                                    
                                                    <div style="display: flex; align-items: center; justify-content: center; min-width: 35px; font-size: 1.2rem;">
                                                        <p class="m-0" style="font-size: 1.2rem;">{{ producto.cantidad }}</p>
                                                    </div>
                                                    <b-button variant="primary" size="sm" @click="incrementarItem(index)">+</b-button>
                                                </div>
                                                <div>
                                                    <p class="pl-4 m-0" v-if="producto.precio_normal!=null"><s>{{ producto.cantidad!=0?format_Valor_variable(parseInt(producto.precio_normal) * producto.cantidad):format_Valor_variable(parseInt(producto.precio_normal)) }}</s></p>
                                                    <p class="pl-4 m-0" v-else><br></p>
                                                    <p class="pl-4 m-0 text-primary">{{ producto.cantidad!=0?format_Valor_variable(parseInt(producto.precio_estudiante) * producto.cantidad):format_Valor_variable(parseInt(producto.precio_estudiante)) }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="offset-md-3 col-md-6">
                                <p class="font-size-14">Para realizar la compra es necesario adjuntar una imagen de la Credencial Universitaria</p>
                                <div class="column-container">
                                    <p class="font-size-20">Total Precio Normal: <span><s>{{ format_Valor_variable(cartTotalP) }} </s></span></p>
                                    <p class="font-size-20">Total Precio Estudiante: <span class="text-primary">{{ format_Valor_variable(cartTotal) }}</span></p>
                                </div>
                                <b-button variant="primary" size="lg" block @click="confirmarSeleccion" :disabled="cartTotal==0">Confirmar y Finalizar Compra</b-button>
                            </div>
                            <b-modal ref="modal_ficha" title="Ficha Técnica del Producto" title-class="text-primary" ok-only ok-title="Cerrar">
                                <div class="row " >
                                    <div class="col-md-12 text-left p-3" style="background-color: #f8f9fa;">
                                        <p class="font-size-16 text-primary" ><b>Nombre Producto:</b> {{ this.producto_ver.producto}}</p>
                                        <p class="font-size-16 text-primary" ><b>Marca:</b> {{ producto_ver.marca }}</p>
                                        <p class="font-size-16 text-primary" ><b>Presentación:</b> {{ producto_ver.presentacion }}</p>
                                        <p class="font-size-16 text-primary" ><b>Características:</b></p>
                                        <p class="font-size-16 text-primary" v-html="formattedText(producto_ver.caracteristicas)">
                                        </p>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="text-center mt-4">
                                            <figure v-if="producto_ver.imagen!=''" style="overflow: hidden;">
                                                <img :src="producto_ver.imagen" class="img-fluid" style="max-width: 100%; height: auto;" alt="Imagen del producto">
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </b-modal>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<style>
.fixed-button {
    width: 80px;  /* Ancho fijo */
    height: 38px; /* Alto fijo, ajusta según sea necesario */
    min-width: 80px;
    min-height: 38px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
}

.column-container p {
    display: flex;
    justify-content: space-between; /* Distribuye el texto y el span */
    align-items: center;
}

.containerb {
    text-align: center;
    width: 90%;
    max-width: 600px;
}
.search-box {
    display: flex;
    align-items: center;
    background: white;
    padding: 5px;
    border-radius: 25px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    margin-bottom: 10px;
}
.search-box input {
    border: none;
    outline: none;
    flex: 1;
    padding: 8px;
    font-size: 16px;
}
.search-box .icon {
    font-size: 20px;
    margin-right: 5px;
    color: gray;
}
.filters {
    display: flex;
    justify-content: center;
    gap: 10px;
}
.filter {
    background: white;
    padding: 8px 15px;
    border-radius: 20px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    font-size: 14px;
    cursor: pointer;
    color:dimgray;
}

</style>